import React from "react";
import PropTypes from "prop-types";
import { useTheme } from "context/AntdThemeContext";
import { useTranslation } from "react-i18next";
import { colorsRGB } from "themes/variables";
import { Flex } from "antd";

export default function CustomPagination({
  metadata = {},
  pageSize,
  total,
  onPageChange,
  onPageSizeChange,
  pageSizeOptions = [10, 20, 30, 50, 100],
  showPageSizeSelector = true,
}) {
  const page = metadata.page || 1;
  const totalPages = metadata.total_pages || Math.ceil(total / pageSize) || 1;
  const nextPage = metadata.next_page;
  const prevPage = metadata.prev_page;
  const from = total === 0 ? 0 : (page - 1) * pageSize + 1;
  const to = Math.min(page * pageSize, total);

  const { t } = useTranslation();

  const { isSportsman } = useTheme();
  const primaryColorRGB = isSportsman
    ? colorsRGB.sportsmanBrand
    : colorsRGB.sportswomanBrand;

  const dropdownBlue = `rgba(${primaryColorRGB}, 1)`;
  const arrowActive = `rgba(${primaryColorRGB}, 0.8)`;
  const arrowInactive = "#bbb";

  return (
    <Flex justify="flex-end" align="center" gap={10} className="p-xs" wrap>
      {showPageSizeSelector && (
        <Flex gap={10}>
          <span>{t("global.rows_per_page")}:</span>
          <select
            value={pageSize}
            onChange={(e) => onPageSizeChange(Number(e.target.value))}
            style={{
              border: "none",
              background: "transparent",
              color: dropdownBlue,
              fontWeight: "bold",
              outline: "none",
            }}
          >
            {pageSizeOptions.map((opt) => (
              <option key={opt} value={opt}>
                {opt}
              </option>
            ))}
          </select>
        </Flex>
      )}
      <Flex justify="center" align="center" gap={16} className="">
        <span>
          {from}-{to} of {total}
        </span>
        <button
          onClick={() => onPageChange(prevPage || page - 1)}
          disabled={!prevPage || page === 1}
          style={{
            background: "none",
            border: "none",
            cursor: !prevPage || page === 1 ? "not-allowed" : "pointer",
            color: !prevPage || page === 1 ? arrowInactive : arrowActive,
            fontSize: 22,
          }}
        >
          {"<"}
        </button>
        <button
          onClick={() => onPageChange(nextPage || page + 1)}
          disabled={!nextPage || page === totalPages || total === 0}
          style={{
            background: "none",
            border: "none",
            cursor:
              !nextPage || page === totalPages || total === 0
                ? "not-allowed"
                : "pointer",
            color:
              !nextPage || page === totalPages || total === 0
                ? arrowInactive
                : arrowActive,
            fontSize: 22,
          }}
        >
          {">"}
        </button>
      </Flex>
    </Flex>
  );
}

CustomPagination.propTypes = {
  metadata: PropTypes.shape({
    page: PropTypes.number,
    total_pages: PropTypes.number,
    next_page: PropTypes.number,
    prev_page: PropTypes.number,
  }),
  pageSize: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  onPageSizeChange: PropTypes.func,
  pageSizeOptions: PropTypes.arrayOf(PropTypes.number),
  showPageSizeSelector: PropTypes.bool,
};

CustomPagination.defaultProps = {
  metadata: {},
  pageSizeOptions: [10, 20, 30, 50, 100],
  showPageSizeSelector: true,
};